export enum FileType {
    Excel = 1,
    Pdf,
    Csv,
    Xml,
    Json
}